import { useState } from "react";
import { X, ArrowRight } from "lucide-react";

const allProjects = [
  { src: "/images/proyecto_galeria_03.jpg", cat: "estacionamientos", loc: "Monterrey, NL · Modelo Curve" },
  { src: "/images/proyecto_galeria_05.jpg", cat: "estacionamientos", loc: "Saltillo, Coah · Back to Back" },
  { src: "/images/proyecto_galeria_06.jpg", cat: "industrial", loc: "Santa Catarina, NL · Industria" },
  { src: "/images/proyecto_galeria_08.jpeg", cat: "estacionamientos", loc: "Monterrey, NL · Back to Back" },
  { src: "/images/proyecto_galeria_11.jpeg", cat: "escuelas", loc: "San Pedro, NL · Walk" },
  { src: "/images/proyecto_galeria_12.jpeg", cat: "estacionamientos", loc: "Torreón, Coah · Curve" },
  { src: "/images/proyecto_galeria_13.jpeg", cat: "industrial", loc: "Apodaca, NL · Toldo industrial" },
  { src: "/images/proyecto_galeria_14.jpg", cat: "estacionamientos", loc: "Guadalupe, NL · Curve" },
  { src: "/images/proyecto_galeria_15.jpg", cat: "residencial", loc: "Monterrey, NL · Residencial" },
  { src: "/images/proyecto_galeria_16.jpeg", cat: "escuelas", loc: "Saltillo, Coah · Colegio" },
  { src: "/images/brochure_img_p6_1.jpeg", cat: "industrial", loc: "Planta industrial · Back to Back" },
  { src: "/images/brochure_img_p2_1.jpeg", cat: "estacionamientos", loc: "Monterrey, NL" },
  { src: "/images/brochure_img_p2_2.jpeg", cat: "estacionamientos", loc: "Monterrey, NL" },
  { src: "/images/brochure_img_p3_5.jpeg", cat: "residencial", loc: "Residencial · Curve Corto" },
];

const filters = [
  { key: "todos", label: "Todos" },
  { key: "estacionamientos", label: "Estacionamientos" },
  { key: "industrial", label: "Industrial" },
  { key: "escuelas", label: "Escuelas" },
  { key: "residencial", label: "Residencial" },
];

export default function Gallery() {
  const [filter, setFilter] = useState("todos");
  const [lightbox, setLightbox] = useState(null);

  const items = filter === "todos" ? allProjects : allProjects.filter((p) => p.cat === filter);

  return (
    <section id="proyectos" className="bg-neutral-50 py-20 md:py-28">
      <div className="container-x">
        <div className="text-center mb-10">
          <span className="eyebrow">Proyectos Reales</span>
          <h2 className="mt-4 section-title text-4xl md:text-6xl font-black">
            Más de <span className="text-red-600">10,000 espacios</span> protegidos
          </h2>
          <p className="mt-4 text-neutral-600 max-w-2xl mx-auto">
            Proyectos reales instalados por Eclipse en toda la República Mexicana.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8">
          {filters.map((f) => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              data-testid={`filter-${f.key}`}
              className={`px-4 py-2 rounded-full text-sm font-semibold border transition ${
                filter === f.key
                  ? "bg-red-600 text-white border-red-600"
                  : "bg-white text-neutral-700 border-neutral-200 hover:border-red-400"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="masonry">
          {items.map((p, i) => (
            <button
              key={i}
              onClick={() => setLightbox(p)}
              className="block w-full rounded-xl overflow-hidden card-lift bg-black"
              data-testid={`gallery-item-${i}`}
            >
              <img src={p.src} alt={p.loc} className="w-full h-auto block" loading="lazy" />
            </button>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-xl md:text-2xl font-bold text-neutral-900">
            Tu espacio puede ser el siguiente.
          </p>
          <a href="#cotizar" className="btn-primary mt-4 px-7 py-3 rounded-xl inline-flex items-center gap-2">
            Cotiza gratis <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
          data-testid="lightbox-backdrop"
        >
          <button
            type="button"
            aria-label="Cerrar"
            data-testid="lightbox-close"
            className="absolute top-4 right-4 text-white p-3 bg-white/10 hover:bg-white/20 rounded-full z-[70]"
            onClick={(e) => { e.stopPropagation(); setLightbox(null); }}
          >
            <X className="w-7 h-7" />
          </button>
          <div className="max-w-5xl max-h-[90vh] w-full" onClick={(e) => e.stopPropagation()}>
            <img src={lightbox.src} alt={lightbox.loc} className="w-full h-auto max-h-[80vh] object-contain rounded-lg" />
            <p className="text-white/80 text-center mt-3 text-sm">{lightbox.loc}</p>
          </div>
        </div>
      )}
    </section>
  );
}
